// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Categorical palette for per-player chart series on the dark panels (#07200D and
// the round bands blended over it, #061A0B–#0F3319). Validated against all three
// surfaces with every pair compared — position lines cross each other, so adjacent
// pair separation is not enough:
//   lightness band OKLCH L 0.48–0.67, chroma >= 0.10, contrast >= 3:1,
//   worst all-pairs CVD ΔE 8.6 (deutan), worst normal-vision ΔE 15.1.
// Five slots is what passes those gates at once; a sixth hue drops the
// normal-vision floor under 15, so extra players share the neutral fallback.
// Assign by series order and never cycle — a colour belongs to a player, not to a
// rank, and the legend carries the name so identity is never colour alone.
export const SERIES_PALETTE = ['#e15a00', '#0096c3', '#00965a', '#7869e1', '#e15a96'];
export const SERIES_FALLBACK = '#8a9a8e';

export const seriesColor = (index: number): string =>
  index < SERIES_PALETTE.length ? SERIES_PALETTE[index] : SERIES_FALLBACK;
